import Breadcrumb from "../../../components/admin/layouts/Breadcrumb/Breadcrumb";
import Container from "../../../components/admin/layouts/Container/Container";
import Header, { HeaderLeft, HeaderRight } from "../../../components/admin/layouts/Header/Header";
import PageWrapper from "../../../components/admin/layouts/PageWrapper/PageWrapper";
import Subheader, {
  SubheaderLeft,
  SubheaderRight,
  SubheaderSeparator,
} from "../../../components/admin/layouts/Subheader/Subheader";
import CompanyImg from "../../../assets/png/company.png";
import DefaultHeaderRightCommon from "../../../templates/layouts/Headers/_common/DefaultHeaderRight.common";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import Button from "../../../components/ui/Button";
import Card, { CardBody, CardHeader, CardHeaderChild, CardTitle } from "../../../components/ui/Card";
import Label from "../../../components/ui/Label";
import Input from "../../../components/form/Input";
import { useFormik } from "formik";
import * as Yup from "yup";
import RichText from "../../../components/ui/RichText";
import classNames from "classnames";
import Icon from "../../../components/icon/Icon";
import themeConfig from "../../../config/theme.config";
import Badge from "../../../components/ui/Badge";
import { DefaultAssetID, Google_map_Key, vizybilityConfig } from "../../../api/url";
// import { useMsal } from "@azure/msal-react"; // Azure B2C - temporarily disabled
import { useEffect, useRef, useState } from "react";
// import { postGetVizyBilityToken } from "../../../services/getVizyBilityToken"; // Azure B2C - temporarily disabled
import { addDays, cleanObjectKeys, formatDate, logoutFun, parseHtmlToText } from "../../../utils/helper";
// import { getAzureUser } from "../../../services/updateAzureUser"; // Azure B2C - temporarily disabled
// import { getGenericUserKey, getThirdPartyAzureService } from "../../../services/getThirdPartyAzureService"; // Azure B2C - temporarily disabled
// import { jwtDecode } from "jwt-decode"; // Azure B2C - temporarily disabled
// import { loginRequest } from "../../../config/msalConfig"; // Azure B2C - temporarily disabled
import { logoutService, clearAuthStorage } from "../../../services/authService";
import { toast } from "react-toastify";
import GooglePlacesAutocomplete from "react-google-autocomplete";
import {
  GetPictureByContext,
  addAsset,
  addAssetAdvertisements,
  addAssetAdvertisementsImg,
  addCategori,
  addLocation,
  checkUnitNumber,
  getAssetAdvByID,
  getAssetByID,
  getAssetIcon,
  getAssetStatuses,
  getContactById,
  getExtraData,
  getExtraDataSchema,
  getLocations,
  saveExtra,
  savePicture,
  uploadBulkImg,
} from "../../../services/vizyBilityServices";
import { ApplicationId } from "../../../api/url";
import Select from "../../../components/form/Select";
import { getAllMachinesMaketList, getCategoryList, getMasterModelsByMake } from "../../../services/machineService";
import { saveCompanyInfo } from "../../../services/companyService";
import { getLocationsByCompanyId } from "../../../services/locationService";
import AddLocationModel from "../locationInfo/addLocationModel";
import AdvertisementsModel from "./model/advertisementsModel";
import SetAsMainModelConformationPopUp from "./model/setAsMainModelConformationPopUp";
import SelectLocationModel from "./model/selectLocationModel";
import Accordion from "../../../components/form/Accordion";
import QuillTextEditor from "../../../components/ui/QuillTextEditor";

const getSlateValue = (value) => {
  if (Array.isArray(value) && value.length > 0) {
    return value;
  }
  if (typeof value === "string") {
    try {
      const parsed = JSON.parse(value);
      if (Array.isArray(parsed) && parsed.length > 0) return parsed;
    } catch (e) {
      // Not a JSON string
    }

    // Handle HTML string - convert breaks to newlines to preserve some formatting
    const tempValue = value.replace(/<br\s*\/?>/gi, "\n");
    const parser = new DOMParser();
    const doc = parser.parseFromString(tempValue, "text/html");
    const text = doc.body.textContent || "";

    return [
      {
        type: "paragraph",
        children: [{ text: text }],
      },
    ];
  }
  return [
    {
      type: "paragraph",
      children: [{ text: "" }],
    },
  ];
};

const AddAsset = () => {
  const navigate = useNavigate();
  // const { instance, accounts } = useMsal(); // Azure B2C - temporarily disabled
  const location = useLocation();

  const params = useParams();
  const editAssetID = params?.id;
  const editMachineInfo = location?.state?.editMachineInfo;
  const Logout = localStorage.getItem("getAzureUserData");
  const azureUserInfo = localStorage.getItem("getAzureUserData")
    ? JSON.parse(localStorage.getItem("getAzureUserData"))
    : null;
  const azurePhoneDigits = String(azureUserInfo?.Phone || "").replace(/\D/g, "");
  const azurePhone =
    azurePhoneDigits.length === 11 && azurePhoneDigits.startsWith("1")
      ? azurePhoneDigits.slice(1)
      : azurePhoneDigits;
  const [openWarning, setOpenWarning] = useState(false);
  const [previewImage, setPreviewImage] = useState(null); // Image for modal preview
  const [images, setImages] = useState([]);
  const [assetType, setAssetType] = useState([]);
  const [assetStatus, setAssetStatus] = useState([]);
  const [assetIcon, setAssetIcon] = useState([]);
  const [assetMake, setAssetMake] = useState([]);
  const [assetModel, setAssetModel] = useState([]);
  const [addMachineLoader, setAddMachineLoader] = useState(false);
  const [refreshPage, setRefreshPage] = useState(false);
  const [openPendingWarning, setOpenPendingWarning] = useState(localStorage.getItem("OpenWarning") || false);
  const [locationList, setLocationList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [advertisementValue, setAdvertisementsValue] = useState({
    AssetAdvertisementId: null,
    AdvertisedPrice: "",
    AdvertisedCurrency: "USD",
    AdDescription: "",
    ContactName: azureUserInfo?.givenName || "",
    ContactEmail: azureUserInfo?.identities?.find((item) => item.signInType === "emailAddress")?.issuerAssignedId || "",
    ContactPhone: azurePhone || "",
    AdStartDate: formatDate(new Date()),
    AdEndDate: formatDate(addDays(new Date(), 30)),
    SortOrder: 1,
    Featured: false,
    Enabled: true, // Temp comment
    AdvertiserIds: [1],
  });

  const [extraData, setExtraData] = useState({ fields: [] });
  const [extraDataSchema, setExtraDataSchema] = useState(null);
  const [extraLoading, setExtraLoading] = useState(null);

  const [selectLocation, setSelectLocation] = useState(false);
  const [advertisementsModel, setAdvertisementsModel] = useState(false);

  const [imgSetAMain, setImgSetAMain] = useState(false);
  const [selectedImgID, setSelectedImgID] = useState(null);
  const [currentAssetData, setCurrentAssetData] = useState(null); // Store fetched asset data

  const inputRef = useRef(null);
  const inputRef2 = useRef(null);
  const formik = useFormik({
    initialValues: {
      year: "",
      type: "",
      model: "",
      serialNumber: "",
      unitNumber: "",
      manufacturers: "",
      machineHours: "",
      smu: formatDate(new Date()),
      description: "",
      status: 1,
      price: "",
      currency: "USD",
      sortOrder: "1",
      images: [],
      LocationId: "",
      AssetStatusId: "",
      Smuunits: "",
      IconID: "",
    },
    validationSchema: Yup.object({
      year: Yup.string().required("Year is required"),
      type: Yup.string().required("Category is required"),
      model: Yup.string().required("Model is required"),
      serialNumber: Yup.string().required("Serial Number is required"),
      unitNumber: Yup.string().required("Unit Number is required"),
      manufacturers: Yup.string().required("Manufacturer is required"),
      smu: Yup.string().required("Machine Hours date is required"),
      machineHours: Yup.string().required("SMU is required"),
      description: Yup.string().required("description is required"),
      images: Yup.array(),
      status: Yup.string().required("Status is required"),
      price: Yup.string().required("Price is required"),
      currency: Yup.string().required("Currency is required"),
      sortOrder: Yup.string(),
      LocationId: Yup.string().required("Location is required"),
      AssetStatusId: Yup.string().required("Asset Status is required"),
    }),
    onSubmit: (values) => {
      if (Logout) {
        handleCheckUnitNumber(values);
      } else {
        console.log("values", values);
      }
    },
  });

  const [theme, setTheme] = useState(document.documentElement.classList.contains("dark") ? "dark" : "light");

  useEffect(() => {
    setTheme(document.documentElement.classList.contains("dark") ? "dark" : "light");
  }, [document.documentElement.classList.contains("dark")]);

  useEffect(() => {
    if (editAssetID) {
      getAssetInfoById(editAssetID);
    }
  }, []);

  useEffect(() => {
    if (Logout) {
      handleGetAssetType();
      handleGetAssetMake();
      handleGetAssetStatus();
      handleGetAssetIcon();
      if (editAssetID) {
        GetAssetImgs();
      } else {
        GetExtraData();
        GetExtraDataSchema();
      }
      setSelectedImgID(null);
    } else {
      setOpenWarning(true);
    }
  }, [refreshPage]);

  useEffect(() => {
    if (localStorage.getItem("StoreMachineData")) {
      const storedData = JSON.parse(localStorage.getItem("StoreMachineData"));
      const data = {
        ...storedData,
        images: JSON.parse(localStorage.getItem("StoreMachineImg")) || [], // Override the images property
      };
      formik.setValues(data); // Set the formik values
    }
  }, []);

  useEffect(() => {
    GetLocationList();
  }, []);

  useEffect(() => {
    if (localStorage.getItem("StoreMachineData")) {
      const storedData = JSON.parse(localStorage.getItem("StoreMachineData"));
      const data = {
        ...storedData,
      };
      formik.setValues(data); // Set the formik values

      // setImages(ImageList);

      let fileList = JSON.parse(localStorage.getItem("StoreMachineImg")) || [];

      const newImages = fileList.map((file) => ({
        file: getPhoto(file?.base64),
        preview: file?.base64,
        New: true,
        sortCount: images?.length + 1,
        AddedToAdvertisement: true,
      }));
      setImages((prev) => [...prev, ...newImages]);
      formik.setFieldValue("images", [...images, ...newImages]);

      formik.setFieldTouched("AssetStatusId", true);
      formik.setFieldTouched("LocationId", true);

      localStorage.removeItem("StoreMachineData");
      localStorage.removeItem("StoreMachineImg");
    }
  }, []);

  // Fetch models when manufacturer/make changes (including on edit/load from storage)
  useEffect(() => {
    console.log("[AddAsset] Manufacturer changed:", formik.values.manufacturers, "AssetMake length:", assetMake.length);
    if (formik.values.manufacturers && assetMake.length > 0) {
      const selectedMake = assetMake.find((item) => item.MakeId == formik.values.manufacturers);
      console.log("[AddAsset] Selected make:", selectedMake);
      if (selectedMake) {
        handleGetAssetModel(selectedMake.MakeName);
      }
    }
  }, [formik.values.manufacturers, assetMake]);

  const getPhoto = (base64File) => {
    let base64 = base64File;
    let base64Parts = base64.split(",");
    let fileFormat = base64Parts[0].split(";")[1];
    let fileContent = base64Parts[1];
    let file = new File([fileContent], "file name here", { type: fileFormat });
    return file;
  };

  const GetExtraDataSchema = async () => {
    setExtraLoading(true);
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };

    const payload = editAssetID
      ? `TableName=Asset&PkFieldName=AssetId&PkValue=${editAssetID}`
      : `TableName=Asset&PkFieldName=AssetId`;
    await getExtraDataSchema(payload, header)
      .then((res) => {
        setExtraDataSchema(res?.data?.[0] || null);
        setExtraLoading(false);
      })
      .catch((err) => {
        setExtraLoading(false);
      });
  };

  const GetExtraData = async () => {
    setExtraLoading(true);
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };

    const payload = editAssetID
      ? `TableName=Asset&PkFieldName=AssetId&PkValue=${editAssetID}`
      : `TableName=Asset&PkFieldName=AssetId`;
    await getExtraData(payload, header)
      .then((res) => {
        setExtraData(res?.data || { fields: [] });
        setExtraLoading(false);
      })
      .catch((err) => {
        setExtraLoading(false);
      });
  };
  const handleDateChange = (e) => {
    const value = e.target.value;
    formik.setFieldValue("smu", e.target.value);
  };

  const getAssetInfoById = (AssetId) => {
    setIsLoading(true);
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };
    const payload = `assetId=${AssetId}`;
    getAssetByID(payload, header)
      .then((res) => {
        setIsLoading(false);
        setCurrentAssetData(res?.data); // Store asset data for advertisement modal
        formik.setValues({
          year: res?.data?.Year,
          type: res?.data?.CategoryId,
          model: res?.data?.Model,
          serialNumber: res?.data?.SerialNumber,
          unitNumber: res?.data?.UnitNumber,
          description: res?.data?.AssetDescription,
          status: res?.data?.AssetStatusId || 1,
          price: res?.data?.Price,
          IconID: res?.data?.IconID,
          images: images?.length ? images : [{ New: false, preview: editMachineInfo?.AssetPictureUrl || res?.data?.AssetPictureUrl }],
          currency: "USD",
          manufacturers: res?.data?.MakeId,
          LocationId: res?.data?.LocationId,
          AssetStatusId: res?.data?.AssetStatusId,
          Smuunits: res?.data?.Smuunits,
          defultLocation: res?.data?.LocationName,
          machineHours: res?.data?.LastKnownSMU,
          smu: res?.data?.LastSMUDate?.split("T")?.[0] || "",
          sortOrder: "1",
        });

        GetExtraData();
        GetExtraDataSchema();
        if (!editAssetID) {
          navigate(`/admin/edit-machine/${AssetId}`, {
            replace: true,
            state: { editMachineInfo: res?.data },
          });
          GetAssetImgs(AssetId);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("err", err);
      });
  };

  const handleGetAssetType = () => {
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };
    getCategoryList(header)
      .then((res) => {
        setAssetType(res.data);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const handleGetAssetStatus = () => {
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };
    getAssetStatuses(header)
      .then((res) => {
        setAssetStatus(res.data);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const handleGetAssetIcon = () => {
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };
    getAssetIcon(header)
      .then((res) => {
        setAssetIcon(res.data);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const handleGetAssetMake = () => {
    getAllMachinesMaketList(false)
      .then((res) => {
        setAssetMake(res.data);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const handleGetAssetModel = (makeName) => {
    console.log("[AddAsset] Fetching models for make:", makeName);
    const payload = {
      applicationId: ApplicationId,
      makeName: [makeName],
      isFromAdvertisement: false
    };

    getMasterModelsByMake(payload)
      .then((res) => {
        console.log("[AddAsset] Models fetched successfully:", res.data);
        setAssetModel(res.data);

        // Check if current model value exists in the new model list
        const currentModel = formik.values.model;
        if (currentModel) {
          const modelExists = res.data.some((item) => item.ModelName === currentModel);
          if (!modelExists) {
            // Model doesn't exist in new list, clear it to show placeholder
            console.log("[AddAsset] Current model not found in new list, clearing...");
            formik.setFieldValue("model", "");
          }
        }
      })
      .catch((err) => {
        console.log("[AddAsset] Error fetching models:", err);
        setAssetModel([]);
        formik.setFieldValue("model", ""); // Clear model on error
      });
  };

  // Handle file selection
  const handleFiles = (files) => {
    const newImages = Array.from(files).map((file) => ({
      file,
      preview: URL.createObjectURL(file),
      New: true,
      sortCount: images?.length + 1,
      AddedToAdvertisement: true,
    }));
    setImages((prev) => [...prev, ...newImages]);
    formik.setFieldValue("images", [...images, ...newImages]);
    // Clear the input field value
    if (inputRef && inputRef.current) {
      inputRef.current.value = "";
    }
    if (inputRef2 && inputRef2.current) {
      inputRef2.current.value = "";
    }
  };
  // Handle drag-and-drop
  const handleDrop = (event) => {
    event.preventDefault();
    handleFiles(event.dataTransfer.files);
  };

  // Remove image
  const removeImage = (index) => {
    const updatedImages = images.filter((_, i) => i !== index);
    setImages(updatedImages);

    // Update Formik's value
    formik.setFieldValue("images", updatedImages);
  };

  // Open preview modal
  const openPreview = (image) => {
    setPreviewImage(image);
  };

  // Close preview modal
  const closePreview = () => {
    setPreviewImage(null);
  };

  const handleCheckSerialNumber = (values) => {
    setAddMachineLoader(true);
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };
    const payload = `number=${values.serialNumber}&isUnitNumber=false${editAssetID ? `&assetId=${editAssetID}` : ""}`;

    checkUnitNumber(payload, header)
      .then((res) => {
        handleAddAsset(values);
      })
      .catch((err) => {
        console.log("err", err);
        toast.error(err.data.message);
        setAddMachineLoader(false);
      });
  };

  const handleCheckUnitNumber = (values) => {
    setAddMachineLoader(true);
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };
    const payload = `number=${values.unitNumber}&isUnitNumber=true${editAssetID ? `&assetId=${editAssetID}` : ""}`;

    checkUnitNumber(payload, header)
      .then((res) => {
        handleCheckSerialNumber(values);
      })
      .catch((err) => {
        console.log("err", err);
        toast.error(err.data.message);
        setAddMachineLoader(false);
      });
  };

  const handleAddAsset = (values) => {
    setAddMachineLoader(true);
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };

    let payload = {
      AssetStatusId: Number(values?.status),
      MakeId: Number(values?.manufacturers),
      AssetTypeId: DefaultAssetID,
      AssetDescription: values?.description,
      Year: Number(values?.year),
      Model: values?.model,
      SerialNumber: values?.serialNumber,
      UnitNumber: values?.unitNumber,
      Price: Number(values?.price),
      LastKnownSMU: values.machineHours,
      LastSMUDate: values.smu,
      ContactId: azureUserInfo?.ContactId,
      CompanyId: azureUserInfo?.CompanyId,
      LocationId: Number(values?.LocationId),
      Smuunits: values?.Smuunits,
      IconID: values?.IconID,
      // AssetStatusId: Number(values?.AssetStatusId),
    };

    if (editAssetID) {
      payload = {
        ...payload,
        AssetId: editAssetID,
      };
    }
    addAsset(payload, header)
      .then((res) => {
        saveDiscription(values, res.data);
      })
      .catch((err) => {
        setAddMachineLoader(false);
        toast.error(err?.data);
      });
  };

  const saveDiscription = (values, data) => {
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };
    let payload = {
      pkFieldValue: data?.AssetId,
      data: extraData,
      schema: extraDataSchema?.Schema ? JSON.parse(extraDataSchema.Schema) : null,
    };
    saveExtra(payload, header)
      .then((res) => {
        handleAddCategori(values, data);
      })
      .catch((err) => {
        setAddMachineLoader(false);
        toast.error(err?.data);
      });
  };

  const handleAddCategori = (values, assetInfo) => {
    const selectCatagory = assetType.find((item) => Number(item.CategoryId) == Number(values?.type));
    let payload = {
      AssetId: assetInfo?.AssetId,
      AssetTypeId: DefaultAssetID,
      CategoryId: Number(values?.type),
      CategorizationBreadcrumb: `Paving Equipment // ${selectCatagory.CategoryName}`,
      CategorizationJson: `{"AssetTypeId":{"key":2,"label":"Paving Equipment"},"CategoryId":{"key":${DefaultAssetID},"label":"${selectCatagory.CategoryName}"}}`,
    };
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };

    addCategori(payload, header)
      .then((res) => {
        uploadImg(values, assetInfo);
      })
      .catch((err) => {
        setAddMachineLoader(false);
        toast.error(err?.data || "Error fetching companies");
      });
  };

  const uploadImg = async (values, assetInfo) => {
    try {
      const header = {
        authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
      };

      // Ensure `images` is available and not empty
      if (!images || images.length === 0) {
        if (advertisementValue?.AdvertisedPrice) {
          handleAddAdvertisements(values, assetInfo, []);
        } else {
          toast.error("No images to upload!");
          setAddMachineLoader(false);
        }
        return;
      }

      const uploadIMG = images.filter((item) => item.New);

      const uploadPromises = uploadIMG.map(async (item, index) => {
        const url = `pictureId=${assetInfo?.CompanyId}&directoryName=Dev`;
        const payload = new FormData();
        payload.append("file", item.file);

        try {
          // Upload image
          const uploadResponse = await uploadBulkImg(payload, header, url);

          // Prepare payload for saving the picture
          let imgPayload = {
            Context: "Asset",
            ContextId: assetInfo?.AssetId, // Replace Asset ID
            url: uploadResponse.data.url,
            PictureUuid: uploadResponse.data.pictureUuid,
            PictureContentType: uploadResponse.data.pictureContentType,
            FileSizeInBytes: uploadResponse.data.file.Length,
            FileName: uploadResponse.data.file.FileName.substring(
              0,
              uploadResponse.data.file.FileName.lastIndexOf(".")
            ),
            FileFullName: uploadResponse.data.file.FileName,
            folderFetachParam: {
              Context: "Asset",
              ContextId: assetInfo?.AssetId, // Replace Asset ID
            },
          };

          if (index == 0) {
            imgPayload = {
              ...imgPayload,
              Main: true, // this flag working for main img set in asset for 1st img
            };
          }
          // Save the picture
          const saveResponse = await savePicture(imgPayload, header);
          return { ...saveResponse?.data, SelectedAdvertisement: item?.AddedToAdvertisement || false };
        } catch (uploadErr) {
          setAddMachineLoader(false);
          console.error("Error uploading image:", uploadErr);
          toast.error(uploadErr?.data || "Image upload failed!");
          throw uploadErr; // Propagate error for outer handling
        }
      });

      // Wait for all uploads to finish
      const ImgList = await Promise.all(uploadPromises);

      const ContextIds = ImgList?.filter((item) => item?.SelectedAdvertisement)?.map((item) => item.PictureId);
      const ContextExistIds = images?.filter((item) => item?.AddedToAdvertisement)?.map((item) => item.PictureId);
      const mergedArray = [
        ...new Set([...ContextIds, ...ContextExistIds].filter((id) => id !== null && id !== undefined)),
      ];
      const hasAdvertisementData = !!advertisementValue?.AdvertisedPrice;
      if (mergedArray?.length > 0 || hasAdvertisementData) {
        handleAddAdvertisements(values, assetInfo, mergedArray);
      } else {
        if (ImgList?.length > 0) {
          const header = {
            authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
          };
          const payload = `assetId=${assetInfo?.AssetId}`;
          await getAssetAdvByID(payload, header)
            .then((res) => {
              const ContextIds = [
                ...(ImgList?.map((item) => item.PictureId) || []),
                ...(images?.filter((item) => item.PictureId).map((item) => item.PictureId) || []),
              ].filter((item) => item !== null);
              handleSetAdvertisementsImg(res?.data?.[0]?.AssetAdvertisementId, ContextIds, assetInfo?.AssetId);
            })
            .catch((err) => {
              setAddMachineLoader(false);
              setIsLoading(false);
            });
        } else {
          getAssetInfoById(editAssetID);
        }
        toast.success("Asset Edit Successfull");
        localStorage.removeItem("StoreMachineData");
        localStorage.removeItem("StoreMachineImg");
        setAddMachineLoader(false);
      }
    } catch (err) {
      console.error("Error in uploadImg:", err);
      toast.error("Failed to upload images!");
      setAddMachineLoader(false);
    } finally {
    }
  };
  const handleAddAdvertisements = async (values, assetInfo, ContextIds) => {
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };
    const url = `contactId=${azureUserInfo?.ContactId}`;

    const contactData = await getContactById(url, header);
    const payload = { ...advertisementValue, AssetId: assetInfo?.AssetId };
    addAssetAdvertisements(payload, header)
      .then((res) => {
        if (ContextIds?.length > 0) {
          handleSetAdvertisementsImg(res?.data?.AssetAdvertisementId, ContextIds, assetInfo?.AssetId);
        } else {
          getAssetInfoById(assetInfo?.AssetId);
          formik.resetForm();
          localStorage.removeItem("StoreMachineData");
          localStorage.removeItem("StoreMachineImg");
          setAddMachineLoader(false);
        }
        toast.success("List Add");
      })
      .catch((err) => {
        setAddMachineLoader(false);
        toast.error(err?.data);
      });
  };

  const handleSetAdvertisementsImg = async (AdvertisementId, ContextIds, AssetID) => {
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };
    const url = `contactId=${azureUserInfo?.ContactId}`;

    const contactData = await getContactById(url, header);
    const payload = {
      Context: "PICTURE",
      ContextIds: ContextIds,
      AdvertisementId: AdvertisementId,
    };
    addAssetAdvertisementsImg(payload, header)
      .then((res) => {
        getAssetInfoById(AssetID);
        formik.resetForm();
        localStorage.removeItem("StoreMachineData");
        localStorage.removeItem("StoreMachineImg");
        setAddMachineLoader(false);
      })
      .catch((err) => {
        setAddMachineLoader(false);
        toast.error(err?.data);
      });
  };
  const handleRedirectCallback = async (response) => {
    // try { // Azure B2C - temporarily disabled
    //   const decodedToken = jwtDecode(response); // Azure B2C - temporarily disabled
    //   if (!decodedToken?.extension_UserStatus) { // Azure B2C - temporarily disabled
    //     await handleDefaultLogin(decodedToken, response); // Azure B2C - temporarily disabled
    //     return; // Azure B2C - temporarily disabled
    //   } // Azure B2C - temporarily disabled
    //   switch (decodedToken.extension_UserStatus) { // Azure B2C - temporarily disabled
    //     case undefined: // Azure B2C - temporarily disabled
    //     case "Pending": // Azure B2C - temporarily disabled
    //       await handlePendingStatus(); // Azure B2C - temporarily disabled
    //       break; // Azure B2C - temporarily disabled
    //     case "Approved": // Azure B2C - temporarily disabled
    //       await handleApprovedStatus(decodedToken); // Azure B2C - temporarily disabled
    //       break; // Azure B2C - temporarily disabled
    //     default: // Azure B2C - temporarily disabled
    //       await handleDefaultStatus(); // Azure B2C - temporarily disabled
    //       break; // Azure B2C - temporarily disabled
    //   } // Azure B2C - temporarily disabled
    // } catch (error) { // Azure B2C - temporarily disabled
    //   console.error("Error handling redirect callback:", error); // Azure B2C - temporarily disabled
    //   setIsLoading(false); // Azure B2C - temporarily disabled
    // } // Azure B2C - temporarily disabled
  };

  const handlePendingStatus = async () => {
    await logoutService(); clearAuthStorage(); localStorage.setItem("OpenWarning", true); navigate("/");
  };

  const handleApprovedStatus = async (decodedToken) => {
    // const payload = new URLSearchParams({ // Azure B2C - temporarily disabled
    //   grant_type: vizybilityConfig.grant_type, // Azure B2C - temporarily disabled
    //   username: decodedToken.extension_GenericWebUsername, // Azure B2C - temporarily disabled
    //   password: decodedToken.extension_GenericWebUserPassword, // Azure B2C - temporarily disabled
    //   client_id: vizybilityConfig.STS_CLIENT_ID, // Azure B2C - temporarily disabled
    //   client_secret: vizybilityConfig.STS_CLIENT_SECRET, // Azure B2C - temporarily disabled
    //   scope: vizybilityConfig.STS_SCOPE, // Azure B2C - temporarily disabled
    //   ApplicationId, // Azure B2C - temporarily disabled
    // }); // Azure B2C - temporarily disabled
    // setIsLoading(true); // Azure B2C - temporarily disabled
    // try { // Azure B2C - temporarily disabled
    //   const res = await postGetVizyBilityToken({ // Azure B2C - temporarily disabled
    //     url: vizybilityConfig.STS_SIGNIN_URL, // Azure B2C - temporarily disabled
    //     payload, // Azure B2C - temporarily disabled
    //   }); // Azure B2C - temporarily disabled
    //   if (res?.data?.access_token) { // Azure B2C - temporarily disabled
    //     localStorage.setItem("vizy-bility-token", res.data.access_token); // Azure B2C - temporarily disabled
    //     localStorage.setItem("client_info", JSON.stringify(decodedToken)); // Azure B2C - temporarily disabled
    //     const header = { authorization: `Bearer ${res.data.access_token}` }; // Azure B2C - temporarily disabled
    //     const ThirdPartyAzureToken = await getThirdPartyAzureService(header); // Azure B2C - temporarily disabled
    //     const headerUser = { Authorization: `Bearer ${ThirdPartyAzureToken?.data?.access_token}` }; // Azure B2C - temporarily disabled
    //     const getGenericUser = await getGenericUserKey(header); // Azure B2C - temporarily disabled
    //     const applicationId = JSON.parse(getGenericUser?.data?.SettingValue)?.AzureB2CApplicationID; // Azure B2C - temporarily disabled
    //     const query = `${decodedToken.sub}?$select=...`; // Azure B2C - temporarily disabled
    //     const AzureUserData = await getAzureUser(query, headerUser); // Azure B2C - temporarily disabled
    //     localStorage.setItem("getAzureUserData", JSON.stringify(cleanObjectKeys(AzureUserData?.data))); // Azure B2C - temporarily disabled
    //     localStorage.removeItem("OpenWarning"); // Azure B2C - temporarily disabled
    //     setIsLoading(false); // Azure B2C - temporarily disabled
    //     setOpenPendingWarning(false); // Azure B2C - temporarily disabled
    //     window.location.reload(); // Azure B2C - temporarily disabled
    //   } // Azure B2C - temporarily disabled
    //   setIsLoading(false); // Azure B2C - temporarily disabled
    // } catch (error) { // Azure B2C - temporarily disabled
    //   await handlePendingStatus(); // Azure B2C - temporarily disabled
    // } // Azure B2C - temporarily disabled
  };

  const handleDefaultLogin = async (decodedToken, response) => {
    // const payload = new URLSearchParams({ // Azure B2C - temporarily disabled
    //   grant_type: vizybilityConfig.grant_type, // Azure B2C - temporarily disabled
    //   username: vizybilityConfig.GenericWebUsername, // Azure B2C - temporarily disabled
    //   password: vizybilityConfig.GenericWebUserPassword, // Azure B2C - temporarily disabled
    //   client_id: vizybilityConfig.STS_CLIENT_ID, // Azure B2C - temporarily disabled
    //   client_secret: vizybilityConfig.STS_CLIENT_SECRET, // Azure B2C - temporarily disabled
    //   scope: vizybilityConfig.STS_SCOPE, // Azure B2C - temporarily disabled
    //   ApplicationId, // Azure B2C - temporarily disabled
    // }); // Azure B2C - temporarily disabled
    // setIsLoading(true); // Azure B2C - temporarily disabled
    // try { // Azure B2C - temporarily disabled
    //   const res = await postGetVizyBilityToken({ // Azure B2C - temporarily disabled
    //     url: vizybilityConfig.STS_SIGNIN_URL, // Azure B2C - temporarily disabled
    //     payload, // Azure B2C - temporarily disabled
    //   }); // Azure B2C - temporarily disabled
    //   if (res?.data?.access_token) { // Azure B2C - temporarily disabled
    //     localStorage.setItem("vizy-bility-token", res.data.access_token); // Azure B2C - temporarily disabled
    //     localStorage.setItem("client_info", JSON.stringify(decodedToken)); // Azure B2C - temporarily disabled
    //     localStorage.setItem("azuretoken", response); // Azure B2C - temporarily disabled
    //     localStorage.setItem("vizy-azure-token", response); // Azure B2C - temporarily disabled
    //     navigate("/admin"); // Azure B2C - temporarily disabled
    //   } // Azure B2C - temporarily disabled
    //   setIsLoading(false); // Azure B2C - temporarily disabled
    // } catch (error) { // Azure B2C - temporarily disabled
    //   await handlePendingStatus(); // Azure B2C - temporarily disabled
    // } // Azure B2C - temporarily disabled
  };

  const handleDefaultStatus = async () => {
    // await handlePendingStatus(); // Azure B2C - temporarily disabled
  };

  const handleOpenWarning = () => {
    setOpenPendingWarning(true);
    localStorage.setItem("OpenWarning", true);
  };

  const GetAssetImgs = (assetIdOverride) => {
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };
    const targetAssetId = assetIdOverride || editAssetID;
    const query = `context=Asset&contextId=${targetAssetId}`;

    GetPictureByContext(query, header)
      .then((res) => {
        // setCompanyImg(res.data);

        let ImageList = [];
        res.data?.map((item, index) => {
          ImageList.push({
            ...item,
            New: false,
            preview: item?.url,
            sortCount: index,
          });
        });
        setImages(ImageList);
      })
      .catch((err) => {
        if (err?.status == 401 || err?.statusText == "Unauthorized") {
          logoutFun();
        }
      });
  };

  const GetLocationList = () => {
    setIsLoading(true);
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };
    getLocationsByCompanyId(Number(azureUserInfo?.CompanyId), header)
      .then((res) => {
        // setPagination({
        //   ...pagination,
        //   totalRecords: res.data.length,
        //   pageCount: res.data.length,
        // });
        setLocationList(res.data);
        setIsLoading(false);
      })
      .catch((err) => {
        if (err?.status == 401 || err?.statusText == "Unauthorized") {
          logoutFun();
        }
      });
  };

  const handleRefreshLocationList = () => {
    GetLocationList();
  };

  const handleSelectLocation = (Id) => {
    formik.setFieldValue("LocationId", Id);
    setSelectLocation(false);
  };
  return (
    <>
      <Header>
        <HeaderLeft>
          <Breadcrumb path="Paving Market / Equipment Assets Info" currentPage="Equipment Assets" />
        </HeaderLeft>
        <HeaderRight>
          <DefaultHeaderRightCommon />
        </HeaderRight>
      </Header>

      <PageWrapper name="Equipment Assets Info">
        <Subheader>
          <SubheaderLeft>
            <Link to={`/admin/equipments`}>
              <Button icon="HeroArrowLeft" className="!px-0">
                Back to List
              </Button>
            </Link>
            <SubheaderSeparator />
            {editAssetID ? "Edit Asset" : "Add Asset"}
            {/* {formik.values.productName ? `${formik.values.productName} - Edit` : "New Product"} */}
          </SubheaderLeft>
          <SubheaderRight>
            <Button variant="solid" onClick={() => formik.submitForm()}>
              Save
            </Button>
          </SubheaderRight>
        </Subheader>

        <Container>
          {isLoading || addMachineLoader ? (
            <div className="fixed w-[100%] h-[100dvh] bg-[#00000066] flex justify-center items-center z-50 top-0 right-0">
              <span className="loader"></span>
            </div>
          ) : null}
          <div className="grid grid-cols-12 gap-4">
            <div className="col-span-12 flex justify-between flex-wrap items-center">
              <h1 className="my-4 font-bold">LIST YOUR MACHINE</h1>
              {/* {editMachineInfo?.AssetId ? ( */}

              <Button
                variant="solid"
                onClick={() => setAdvertisementsModel(true)}
                className="!bg-[#FEBA06] border-none !text-black px-[20px] py-[12px] rounded-xl font-medium"
              >
                Add Advertisements
              </Button>

              {/* ) : (
                <div></div>
              )} */}
            </div>

            {/* =================================== */}

            <div className="col-span-12 lg:col-span-9">
              <div className="grid grid-cols-12 gap-4">
                <div className="col-span-12">
                  <Accordion title="General Info" defaultOpen={true}>
                    <div className="grid grid-cols-12 gap-4">
                      <div className="col-span-12 lg:col-span-4">
                        <Label htmlFor="id">Manufacturer</Label>

                        <Select
                          name="manufacturers"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.manufacturers}
                          placeholder="Select role"
                        >
                          <option value="" disabled>
                            <div className="!my-[10px] !mx-[30px] leading-[200px]">Select Manufacturers</div>
                          </option>
                          {assetMake.map((item) => {
                            return (
                              <option
                                className="w-full appearance-none outline-0 text-black dark:text-white disabled:!opacity-25 transition-all duration-300 ease-in-out border-2 border-zinc-100 dark:border-zinc-800 bg-zinc-100 dark:bg-zinc-800 hover:border-blue-500 dark:hover:border-blue-500 disabled:!border-zinc-500 focus:border-zinc-300 dark:focus:border-zinc-800 focus:bg-transparent dark:focus:bg-transparent px-1.5 py-1.5 text-base rounded-lg"
                                value={item.MakeId}
                              >
                                <div className="!my-[10px] !mx-[30px] leading-[200px]">{item.MakeName}</div>
                              </option>
                            );
                          })}
                        </Select>
                        {formik.touched.manufacturers && formik.errors.manufacturers ? (
                          <p className="text-red-400 mt-1 text-[14px]">{formik.errors.manufacturers}</p>
                        ) : null}
                      </div>
                      <div className="col-span-12 lg:col-span-4">
                        <Label htmlFor="id">Model</Label>
                        <Select
                          name="model"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.model}
                          placeholder="Select Model"
                        >
                          <option value="" className="text-[16px] text-[#161616] font-[Roboto]" disabled>
                            <div className="!my-[10px] !mx-[30px] leading-[200px]">Select Model</div>
                          </option>
                          {assetModel.map((item) => {
                            return (
                              <option
                                className="w-full appearance-none outline-0 text-black dark:text-white disabled:!opacity-25 transition-all duration-300 ease-in-out border-2 border-zinc-100 dark:border-zinc-800 bg-zinc-100 dark:bg-zinc-800 hover:border-blue-500 dark:hover:border-blue-500 disabled:!border-zinc-500 focus:border-zinc-300 dark:focus:border-zinc-800 focus:bg-transparent dark:focus:bg-transparent px-1.5 py-1.5 text-base rounded-lg"
                                value={item.ModelName}
                              >
                                <div className="!my-[10px] !mx-[30px] leading-[200px]">{item.ModelName}</div>
                              </option>
                            );
                          })}
                        </Select>
                        {formik.touched.model && formik.errors.model ? (
                          <p className="text-red-400 mt-1 text-[14px]">{formik.errors.model}</p>
                        ) : null}
                      </div>
                      <div className="col-span-12 lg:col-span-4">
                        <Label htmlFor="id">Unit Number</Label>
                        <Input
                          type="text"
                          name="unitNumber"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.unitNumber}
                          placeholder="Enter here"
                        />
                        {formik.touched.unitNumber && formik.errors.unitNumber ? (
                          <p className="text-red-400 mt-1 text-[14px]">{formik.errors.unitNumber}</p>
                        ) : null}
                      </div>
                      <div className="col-span-12 lg:col-span-4">
                        <Label htmlFor="id">Serial Number</Label>
                        <Input
                          type="text"
                          name="serialNumber"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.serialNumber}
                          placeholder="Enter here"
                        />
                        {formik.touched.serialNumber && formik.errors.serialNumber ? (
                          <p className="text-red-400 mt-1 text-[14px]">{formik.errors.serialNumber}</p>
                        ) : null}
                      </div>
                      <div className="col-span-12 lg:col-span-4">
                        <Label htmlFor="id">Asset Status</Label>
                        <Select
                          name="AssetStatusId"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.AssetStatusId}
                          placeholder="Select Location"
                        >
                          <option
                            value=""
                            disabled
                            className="w-full appearance-none outline-0 text-black dark:text-white disabled:!opacity-25 transition-all duration-300 ease-in-out border-2 border-zinc-100 dark:border-zinc-800 bg-zinc-100 dark:bg-zinc-800 hover:border-blue-500 dark:hover:border-blue-500 disabled:!border-zinc-500 focus:border-zinc-300 dark:focus:border-zinc-800 focus:bg-transparent dark:focus:bg-transparent px-1.5 py-1.5 text-base rounded-lg"
                          >
                            Select Location
                          </option>
                          {assetStatus.map((item) => {
                            return (
                              <option
                                class="w-full appearance-none outline-0 text-black dark:text-white disabled:!opacity-25 transition-all duration-300 ease-in-out border-2 border-zinc-100 dark:border-zinc-800 bg-zinc-100 dark:bg-zinc-800 hover:border-blue-500 dark:hover:border-blue-500 disabled:!border-zinc-500 focus:border-zinc-300 dark:focus:border-zinc-800 focus:bg-transparent dark:focus:bg-transparent px-1.5 py-1.5 text-base rounded-lg"
                                value={item.AssetStatusId}
                              >
                                {item?.AssetStatusName}
                              </option>
                            );
                          })}
                        </Select>
                        {formik.touched.AssetStatusId && formik.errors.AssetStatusId ? (
                          <p className="text-red-400 mt-1 text-[14px]">{formik.errors.AssetStatusId}</p>
                        ) : null}
                      </div>
                      <div className="col-span-12 lg:col-span-4">
                        <Label htmlFor="id">Year</Label>
                        <Input
                          type="number"
                          id="year"
                          name="year"
                          onChange={formik.handleChange}
                          value={formik.values.year}
                          placeholder="Enter here"
                        />
                        {formik.touched.year && formik.errors.year ? (
                          <p className="text-red-400 mt-1 text-[14px]">{formik.errors.year}</p>
                        ) : null}
                      </div>
                      <div className="col-span-12 lg:col-span-4">
                        <Label htmlFor="id">Category</Label>

                        <Select
                          name="type"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.type}
                          placeholder="Select Category"
                        >
                          <option
                            value=""
                            disabled
                            className="w-full appearance-none outline-0 text-black dark:text-white disabled:!opacity-25 transition-all duration-300 ease-in-out border-2 border-zinc-100 dark:border-zinc-800 bg-zinc-100 dark:bg-zinc-800 hover:border-blue-500 dark:hover:border-blue-500 disabled:!border-zinc-500 focus:border-zinc-300 dark:focus:border-zinc-800 focus:bg-transparent dark:focus:bg-transparent px-1.5 py-1.5 text-base rounded-lg"
                          >
                            Select Category
                          </option>
                          {assetType.map((item) => {
                            return (
                              <option
                                class="w-full appearance-none outline-0 text-black dark:text-white disabled:!opacity-25 transition-all duration-300 ease-in-out border-2 border-zinc-100 dark:border-zinc-800 bg-zinc-100 dark:bg-zinc-800 hover:border-blue-500 dark:hover:border-blue-500 disabled:!border-zinc-500 focus:border-zinc-300 dark:focus:border-zinc-800 focus:bg-transparent dark:focus:bg-transparent px-1.5 py-1.5 text-base rounded-lg"
                                value={item.CategoryId}
                              >
                                {item.CategoryName}
                              </option>
                            );
                          })}
                        </Select>
                        {formik.touched.type && formik.errors.type ? (
                          <p className="text-red-400 mt-1 text-[14px]">{formik.errors.type}</p>
                        ) : null}
                      </div>
                      <div className="col-span-12 lg:col-span-4">
                        <Label htmlFor="id">Machine Hours</Label>
                        <Input
                          type="number"
                          name="machineHours"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.machineHours}
                          placeholder="Enter here"
                        />
                        {formik.touched.machineHours && formik.errors.machineHours ? (
                          <p className="text-red-400 mt-1 text-[14px]">{formik.errors.machineHours}</p>
                        ) : null}
                      </div>
                      <div className="col-span-12 lg:col-span-4">
                        <Label htmlFor="id">Machine Hours As of</Label>
                        <Input
                          type="date"
                          name="smu"
                          onChange={handleDateChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.smu}
                          placeholder="Enter here"
                        />
                        {formik.touched.smu && formik.errors.smu ? (
                          <p className="text-red-400 mt-1 text-[14px]">{formik.errors.smu}</p>
                        ) : null}
                      </div>
                      <div className="col-span-12 lg:col-span-4">
                        <Label htmlFor="id">Icon</Label>
                        <div className="flex items-center">
                          <Select
                            name="IconID"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.IconID}
                            placeholder="Select Icon"
                          >
                            <option
                              value=""
                              className="w-full appearance-none outline-0 text-black dark:text-white disabled:!opacity-25 transition-all duration-300 ease-in-out border-2 border-zinc-100 dark:border-zinc-800 bg-zinc-100 dark:bg-zinc-800 hover:border-blue-500 dark:hover:border-blue-500 disabled:!border-zinc-500 focus:border-zinc-300 dark:focus:border-zinc-800 focus:bg-transparent dark:focus:bg-transparent px-1.5 py-1.5 text-base rounded-lg"
                            >
                              Select Icon
                            </option>
                            {assetIcon.map((item) => {
                              return (
                                <option
                                  class="w-full appearance-none outline-0 text-black dark:text-white disabled:!opacity-25 transition-all duration-300 ease-in-out border-2 border-zinc-100 dark:border-zinc-800 bg-zinc-100 dark:bg-zinc-800 hover:border-blue-500 dark:hover:border-blue-500 disabled:!border-zinc-500 focus:border-zinc-300 dark:focus:border-zinc-800 focus:bg-transparent dark:focus:bg-transparent px-1.5 py-1.5 text-base rounded-lg"
                                  value={item.IconID}
                                >
                                  {item.IconName}
                                </option>
                              );
                            })}
                          </Select>

                          {formik.values.IconID && (
                            <img
                              src={assetIcon?.find((item) => item.IconID === formik.values.IconID)?.IconURL}
                              className="max-h-[31px] w-auto"
                            />
                          )}
                        </div>
                        {formik.touched.IconID && formik.errors.IconID ? (
                          <p className="text-red-400 mt-1 text-[14px]">{formik.errors.IconID}</p>
                        ) : null}
                      </div>
                      <div className="col-span-12 lg:col-span-4">
                        <Label htmlFor="id">Price</Label>
                        <Input
                          type="number"
                          name="price"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.price}
                          placeholder="Enter here"
                        />
                        {formik.touched.price && formik.errors.price ? (
                          <p className="text-red-400 mt-1 text-[14px]">{formik.errors.price}</p>
                        ) : null}
                      </div>

                      <div className="col-span-12 lg:col-span-4">
                        <Label htmlFor="id">Service Meter Units</Label>

                        <Select
                          name="Smuunits"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.Smuunits}
                          placeholder="Select Service Meter Units"
                        >
                          <option
                            value=""
                            className="w-full appearance-none outline-0 text-black dark:text-white disabled:!opacity-25 transition-all duration-300 ease-in-out border-2 border-zinc-100 dark:border-zinc-800 bg-zinc-100 dark:bg-zinc-800 hover:border-blue-500 dark:hover:border-blue-500 disabled:!border-zinc-500 focus:border-zinc-300 dark:focus:border-zinc-800 focus:bg-transparent dark:focus:bg-transparent px-1.5 py-1.5 text-base rounded-lg"
                          >
                            Select Service Meter Units
                          </option>
                          <option
                            class="w-full appearance-none outline-0 text-black dark:text-white disabled:!opacity-25 transition-all duration-300 ease-in-out border-2 border-zinc-100 dark:border-zinc-800 bg-zinc-100 dark:bg-zinc-800 hover:border-blue-500 dark:hover:border-blue-500 disabled:!border-zinc-500 focus:border-zinc-300 dark:focus:border-zinc-800 focus:bg-transparent dark:focus:bg-transparent px-1.5 py-1.5 text-base rounded-lg"
                            value={"Hours"}
                          >
                            {"Hours"}
                          </option>
                          <option
                            class="w-full appearance-none outline-0 text-black dark:text-white disabled:!opacity-25 transition-all duration-300 ease-in-out border-2 border-zinc-100 dark:border-zinc-800 bg-zinc-100 dark:bg-zinc-800 hover:border-blue-500 dark:hover:border-blue-500 disabled:!border-zinc-500 focus:border-zinc-300 dark:focus:border-zinc-800 focus:bg-transparent dark:focus:bg-transparent px-1.5 py-1.5 text-base rounded-lg"
                            value={"Miles"}
                          >
                            {"Miles"}
                          </option>
                          <option
                            class="w-full appearance-none outline-0 text-black dark:text-white disabled:!opacity-25 transition-all duration-300 ease-in-out border-2 border-zinc-100 dark:border-zinc-800 bg-zinc-100 dark:bg-zinc-800 hover:border-blue-500 dark:hover:border-blue-500 disabled:!border-zinc-500 focus:border-zinc-300 dark:focus:border-zinc-800 focus:bg-transparent dark:focus:bg-transparent px-1.5 py-1.5 text-base rounded-lg"
                            value={"Kilometers"}
                          >
                            {"Kilometers"}
                          </option>
                        </Select>
                        {formik.touched.Smuunits && formik.errors.Smuunits ? (
                          <p className="text-red-400 mt-1 text-[14px]">{formik.errors.Smuunits}</p>
                        ) : null}
                      </div>
                      <div className="col-span-12 lg:col-span-4">
                        <Label htmlFor="id">Location</Label>
                        <div className="flex items-center">
                          <div
                            onClick={() => setSelectLocation(true)}
                            className="w-full outline-0 text-black dark:text-white disabled:!opacity-1 transition-all duration-300 ease-in-out border-2  dark:border-zinc-800 bg-zinc-100 dark:bg-zinc-800 hover:border-blue-500 dark:hover:border-blue-500 !border-zinc-500 disabled:!border-none focus:border-zinc-300 dark:focus:border-zinc-800 focus:bg-transparent dark:focus:bg-transparent px-1.5 py-1.5 text-base rounded-lg h-[31.56px] cursor-pointer overflow-hidden  "
                          >
                            {locationList?.find((item) => item.LocationId == formik.values.LocationId)?.LocationName ||
                              "Select Location"}
                          </div>

                          {/* <Select
                              name="LocationId"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values.LocationId}
                              placeholder="Select Location"
                            >
                              <option
                                value=""
                                disabled
                                className="w-full appearance-none outline-0 text-black dark:text-white disabled:!opacity-25 transition-all duration-300 ease-in-out border-2 border-zinc-100 dark:border-zinc-800 bg-zinc-100 dark:bg-zinc-800 hover:border-blue-500 dark:hover:border-blue-500 disabled:!border-zinc-500 focus:border-zinc-300 dark:focus:border-zinc-800 focus:bg-transparent dark:focus:bg-transparent px-1.5 py-1.5 text-base rounded-lg"
                              >
                                Select Location
                              </option>
                              {locationList.map((item) => {
                                return (
                                  <option
                                    class="w-full appearance-none outline-0 text-black dark:text-white disabled:!opacity-25 transition-all duration-300 ease-in-out border-2 border-zinc-100 dark:border-zinc-800 bg-zinc-100 dark:bg-zinc-800 hover:border-blue-500 dark:hover:border-blue-500 disabled:!border-zinc-500 focus:border-zinc-300 dark:focus:border-zinc-800 focus:bg-transparent dark:focus:bg-transparent px-1.5 py-1.5 text-base rounded-lg"
                                    value={item.LocationId}
                                  >
                                    {item?.LocationName} {item?.Address1 ? `(${item?.Address1})` : null}
                                  </option>
                                );
                              })}
                            </Select> */}

                          {/* <Icon
                              icon={"HeroPlus"}
                              className={classNames(
                                "text-[22px] fill-black dark:text-white text-black cursor-pointer ml-[5px]",
                                themeConfig.transition
                              )}
                              onClick={() => setAddLocationModel(true)}
                            />

                            <Icon
                              icon={"EditIcon"}
                              className={classNames(
                                "text-[22px]  dark:text-transparent text-transparent fill-black dark:fill-white cursor-pointer ml-[5px]",
                                themeConfig.transition
                              )}
                              onClick={() => setEditLocationModel(true)}
                            /> */}
                        </div>
                        {/* <GooglePlacesAutocomplete
                            apiKey={Google_map_Key}
                            onPlaceSelected={(place) => handlePlaceSelect(place, formik)}
                            onChange={(e) => {
                              formik.setValues({
                                ...formik.values,
                                location: e.target.value,
                              });
                            }}
                            options={{
                              types: ["address"],
                            }}
                            value={formik.values.location}
                            className="w-full appearance-none outline-0 text-black dark:text-white disabled:!opacity-25 transition-all duration-300 ease-in-out border-2 border-zinc-100 dark:border-zinc-800 bg-zinc-100 dark:bg-zinc-800 hover:border-blue-500 dark:hover:border-blue-500 disabled:!border-zinc-500 focus:border-zinc-300 dark:focus:border-zinc-800 focus:bg-transparent dark:focus:bg-transparent px-1.5 py-1.5 text-base rounded-lg"
                          /> */}
                        {formik.touched.LocationId && formik.errors.LocationId ? (
                          <p className="text-red-400 mt-1 text-[14px]">{formik.errors.LocationId}</p>
                        ) : null}
                      </div>
                      <div className="col-span-12">
                        <Label htmlFor="description">Note</Label>
                        <div className="w-full appearance-none overflow-hidden outline-0 transition-all duration-300 ease-in-out rounded-lg border-2 border-zinc-100 dark:border-zinc-800 bg-zinc-100 dark:bg-zinc-800 hover:border-blue-500 dark:hover:border-blue-500">
                          <textarea
                            type="text"
                            name="description"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.description}
                            placeholder="Enter here"
                            className="input bg-zinc-100 dark:bg-zinc-800 text-black dark:text-white w-full py-[14px] px-[5px] font-[Roboto] font-normal focus:outline-none rounded-lg"
                          />
                        </div>
                        {formik.touched.description && formik.errors.description ? (
                          <p className="text-red-400 mt-1 text-[14px]">{formik.errors.description}</p>
                        ) : null}
                      </div>
                    </div>
                  </Accordion>
                </div>

                <div className="col-span-12">
                  <Accordion title="Image">
                    <div
                      className={classNames(
                        "mt-2",
                        "flex justify-center",
                        "rounded-lg",
                        "border border-dashed border-zinc-500/25",
                        "px-6 py-10",
                        "dark:border-zinc-500/50"
                      )}
                      onDragOver={(e) => e.preventDefault()}
                      onDrop={handleDrop}
                    >
                      <div className="text-center">
                        <Icon
                          icon="HeroPhoto"
                          className="mx-auto h-12 w-12"
                          color={themeConfig.themeColor}
                          colorIntensity={themeConfig.themeColorShade}
                        />
                        <div className="mt-4 flex text-sm leading-6 text-gray-500">
                          <label
                            htmlFor="file-upload"
                            className={classNames(
                              "relative",
                              "cursor-pointer",
                              "rounded-md",
                              "font-semibold",
                              "text-blue-500",
                              "focus-within:outline-none",
                              "focus-within:ring-2 focus-within:ring-blue-600 focus-within:ring-offset-2 focus-within:ring-offset-transparent",
                              "hover:text-blue-600",
                              themeConfig.transition
                            )}
                          >
                            <span>Upload a file</span>
                            <input
                              id="file-upload"
                              name="file-upload"
                              type="file"
                              multiple
                              className="sr-only"
                              ref={inputRef2}
                              onChange={(e) => handleFiles(e.target.files)}
                            />
                          </label>
                          <span className="pl-1">or drag and drop</span>
                        </div>
                        <p className="text-xs leading-5 text-gray-500">PNG, JPG</p>
                      </div>
                      <input
                        type="file"
                        id="fileInput"
                        className="hidden"
                        multiple
                        accept="image/*"
                        ref={inputRef}
                        onChange={(e) => handleFiles(e.target.files)}
                      />
                    </div>
                    {formik.touched.images && formik.errors.images ? (
                      <p className="text-red-400 mt-1 text-[14px]">{formik.errors.images}</p>
                    ) : null}
                  </Accordion>
                </div>

                <div className="col-span-12">
                  {extraLoading ? (
                    <div className="col-span-12">
                      <div role="status" className="animate-pulse">
                        <div className="h-[300px] bg-gray-200 rounded-lg dark:bg-gray-700"></div>
                        <span className="sr-only">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    <Accordion title="Description">
                      {extraDataSchema?.Schema && (
                        <>
                          {JSON.parse(extraDataSchema?.Schema || "")
                            ?.fields?.sort((a, b) => Number(a.order) - Number(b.order))
                            .map((item, index) => {
                              return (
                                <div className="mb-[20px]">
                                  <div className="text-[16px] font-medium pb-[10px]">{item.label} </div>
                                  <div className="border">
                                    {/* <RichText
                                      handleChange={(value) => {
                                        setExtraData((prevData) => {
                                          const updatedFields = prevData.fields.map((extraDataItem) =>
                                            extraDataItem.name === item.name
                                              ? { ...extraDataItem, value }
                                              : extraDataItem
                                          );
                                          return { ...prevData, fields: updatedFields };
                                        });
                                      }}
                                      id={`${index}-${theme}`}
                                      key={`${index}-${theme}`}
                                      value={getSlateValue(
                                        extraData?.fields?.find((extraDataItem) => extraDataItem?.name === item?.name)
                                          ?.value
                                      )}
                                      placeholder={item.label}
                                    /> */}
                                    <QuillTextEditor
                                      handleChange={(value) => {
                                        setExtraData((prevData) => {
                                          const updatedFields = prevData.fields.map((extraDataItem) =>
                                            extraDataItem.name === item.name
                                              ? { ...extraDataItem, value }
                                              : extraDataItem
                                          );
                                          return { ...prevData, fields: updatedFields };
                                        });
                                      }}
                                      id={`${index}-${theme}`}
                                      key={`${index}-${theme}`}
                                      value={
                                        extraData?.fields?.find((extraDataItem) => extraDataItem?.name === item?.name)
                                          ?.value
                                      }
                                      placeholder={item.label}
                                    />
                                  </div>
                                </div>
                              );
                            })}
                        </>
                      )}
                    </Accordion>
                  )}
                </div>
              </div>
            </div>
            <div className="col-span-12 lg:col-span-3">
              <Card className="top-scroll-offset sticky">
                <CardHeader>
                  <CardHeaderChild>
                    <CardTitle>Image Preview</CardTitle>
                  </CardHeaderChild>
                  <CardHeaderChild>
                    <Button icon="HeroArrowTopRightOnSquare" />
                  </CardHeaderChild>
                </CardHeader>
                <CardBody>
                  <div className="flex flex-col gap-4 max-h-[500px] overflow-auto">
                    {" "}
                    {images?.length <= 0 ? (
                      <div className="flex w-full items-center justify-center text-center h-[300px]">
                        <CardTitle>No Image Available</CardTitle>
                      </div>
                    ) : (
                      <div className="mt-[20px] grid-cols-1">
                        {images
                          .sort((a, b) => b.sortCount - a.sortCount)
                          .map((image, index) => (
                            <div
                              key={index}
                              className={`${image?.Main ? "border-[2px] border-[#4BB543]" : ""
                                } relative group border rounded-lg overflow-hidden my-[10px]`}
                            >
                              {/* Image */}
                              <img
                                src={image.preview}
                                alt={`Preview ${index}`}
                                className="w-full h-[170px] object-cover"
                              />

                              {/* Hover Preview */}
                              <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                <div className="flex flex-col">
                                  {editAssetID && !image?.Main && (
                                    <div className="mb-[5px]">
                                      <button
                                        className="text-white text-sm bg-[#4BB543] py-1 px-3 rounded hover:bg-[#4bb54387]"
                                        onClick={() => {
                                          setImgSetAMain(true);
                                          setSelectedImgID(image?.PictureId);
                                        }}
                                      >
                                        Set as Main
                                      </button>
                                    </div>
                                  )}
                                  <button
                                    className="text-white text-sm bg-gray-700 py-1 px-3 rounded hover:bg-gray-800 mt-[5px]"
                                    onClick={() => openPreview(image.preview)}
                                  >
                                    Preview
                                  </button>
                                </div>
                              </div>

                              {/* Remove Button */}
                              {image?.New && (
                                <button
                                  className="absolute top-2 right-2 bg-red-600 text-white rounded-full p-1 text-xs hover:bg-red-700 w-[20px] h-[20px]"
                                  onClick={() => removeImage(index)}
                                >
                                  ✕
                                </button>
                              )}
                            </div>
                          ))}
                      </div>
                    )}
                  </div>
                </CardBody>
              </Card>
            </div>
          </div>
          {previewImage && (
            <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50">
              <div className="relative bg-zinc-100 dark:bg-zinc-800 p-4 rounded-lg max-w-[90%] max-h-[90%]">
                <button
                  className="absolute top-2 right-2 bg-red-600 text-white rounded-full p-2 hover:bg-red-700  w-[30px] h-[30px] cursor-pointer flex items-center justify-center"
                  onClick={closePreview}
                >
                  ✕
                </button>
                <img src={previewImage} alt="Preview" className="max-w-full max-h-[80vh] object-contain" />
              </div>
            </div>
          )}
        </Container>
      </PageWrapper>

      {advertisementsModel && (
        <AdvertisementsModel
          modalStatus={advertisementsModel}
          setModalStatus={setAdvertisementsModel}
          AssetId={editAssetID}
          assetData={currentAssetData}
          setAdvertisementsValue={setAdvertisementsValue}
          advertisementValue={advertisementValue}
          images={images}
          setImages={setImages}
        />
      )}

      {imgSetAMain && (
        <SetAsMainModelConformationPopUp
          modalStatus={imgSetAMain}
          setModalStatus={setImgSetAMain}
          AssetId={editAssetID}
          pictureId={selectedImgID}
          refresh={() => setRefreshPage(!refreshPage)}
        />
      )}

      {selectLocation && (
        <SelectLocationModel
          modalStatus={selectLocation}
          setModalStatus={setSelectLocation}
          refresh={handleRefreshLocationList}
          handleSelectLocation={handleSelectLocation}
          selectLocationId={formik.values.LocationId}
        />
      )}
    </>
  );
};
export default AddAsset;
